import { Component, Inject, Optional, OnInit, NgModule, LOCALE_ID } from '@angular/core';
import { Location } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { AUTH_ENABLED } from './app.tokens';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Profil von Gerd Gruber';
  defaultTitle: string = '';

  constructor(@Optional() @Inject(AUTH_ENABLED) public authEnabled: any,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private location: Location,
              private titleService: Title,
              @Inject(LOCALE_ID) public locale: string) {
  }

  ngOnInit() {
    this.defaultTitle = this.titleService.getTitle();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.setBrowserTitle();
      });

    const absoluteUrl = this.location.path().split('?')[0];
    let toTheTopAnchor = document.getElementById('to_the_top');
    if (toTheTopAnchor) {
      toTheTopAnchor.setAttribute("href", '/' + this.locale + absoluteUrl + '#start');
    }
  }

  setBrowserTitle() {
    let title = this.defaultTitle;
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
      title = route.snapshot.data['title'] || title;
    }

    this.titleService.setTitle(title);
  }

}
